import { ConstantsRepository } from '@core/repositories/constants.repository';
import { Constant } from '@shared/interfaces/constant';
import { Observable, of, throwError } from 'rxjs';

interface ResultConstants {
  id: string;
  attributes: {
    name: string;
    description: string;
    value: string;
  };
}

export class FakeConstantsRepository implements ConstantsRepository {
  url: string;

  dataConstants: Array<ResultConstants> = [
    {
      id: '1',
      attributes: {
        name: 'DaysToUpdate',
        description: 'Días para actualizar',
        value: '00'
      }
    },
    {
      id: '2',
      attributes: {
        name: 'YearsToUpdate',
        description: 'Años para actualizar',
        value: '11'
      }
    },
    {
      id: '3',
      attributes: {
        name: 'CashIn',
        description: 'Tope de inicio',
        value: '22'
      }
    },
    {
      id: '4',
      attributes: {
        name: 'CashOut',
        description: 'Tope de fin',
        value: '33'
      }
    }
  ];

  constants = {
    data: this.dataConstants
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.constants);
  }

  edit(constant: Constant): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
